import { render, staticRenderFns } from "./ModalReceiptTemplateRemark.vue?vue&type=template&id=25181645&"
import script from "./ModalReceiptTemplateRemark.vue?vue&type=script&lang=js&"
export * from "./ModalReceiptTemplateRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports